import 'choerodon-ui/lib/message/style';
